export default __webpack_public_path__ + "static/media/homewise-logo.536e08bf.png";